export default __webpack_public_path__ + "static/media/BLR9.19f0846a.jpg";